import { FilterType, Filter, CountryCategory, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';

const EvidenceRequirementsOptions = [
  {
    label: 'Standard',
    value: CountryCategory.STANDARD,
  },
  {
    label: 'Differential (Low risk)',
    value: CountryCategory.DIFFERENTIAL,
  },
];

const key = FilterKey.EVIDENCE_REQUIREMENTS;
export const getEvidenceRequirementsFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const filters = activeFilters[key] ?? [];
  const options = EvidenceRequirementsOptions.map(({ label, value }) => {
    return {
      label,
      value,
      checked: filters.some(filter => filter === value),
    };
  });

  return {
    name: 'Evidence requirements (Based on nationality)',
    key,
    type: FilterType.SELECT_MANY,
    options: {
      SELECT_MANY: options,
    },
  };
};
